module.exports = __webpack_public_path__ + "images/iStock-11369053431.png";